export default {"src":"/_next/static/media/usdc-icon.09af89a5.svg","height":38,"width":38};